import React from 'react';
import {SearchInternet, SearchCodebase} from './tools/SearchTools';
import {GenerateImages} from './tools/ImageTools';
import {EditFile, CreateFile, DeleteFile, MoveFile} from './tools/FileTools';
import {RunTerminalCommand} from './tools/TerminalTools';

import {CreatePdf} from './tools/PdfTools';
import {CreateDocx} from './tools/DocxTools';
import {GatherContext} from './tools/GatherContext.tsx';
import {GrepCodebase, OpenFile, ViewDirectory} from './tools/GrepTools';
import {ReviewChanges} from './tools/ReviewChangesTools';
import {useAppStore} from "../../../../../../GlobalStore/GlobalStore.ts";

interface ToolCallProps {
    item: any;
    isInProgress?: boolean;
}

const ToolCall: React.FC<ToolCallProps> = ({ item, isInProgress: propIsInProgress }) => {
    if (!item || typeof item !== 'object') return null;

    const dynamicStateObj = useAppStore((state: any) => state.dynamicStateObj);
    const { elementsInProgress } = dynamicStateObj;
    const storeIsInProgress = elementsInProgress.has(item.id);

    // Use prop isInProgress if provided, otherwise use store value
    const isInProgress = propIsInProgress !== undefined ? propIsInProgress : storeIsInProgress;

    const toolComponents: { [key: string]: React.FC<any> } = {
        searchInternet: SearchInternet,
        generateImages: GenerateImages,
        editFile: EditFile,
        createFile: CreateFile,
        deleteFile: DeleteFile,
        moveFile: MoveFile,
        runTerminalCommand: RunTerminalCommand,
        searchCodebase: SearchCodebase,
        createPdf: CreatePdf,
        createDocx: CreateDocx,
        gatherContext: GatherContext,
        deepResearch: GatherContext,
        grepCodebase: GrepCodebase,
        openFile: OpenFile,
        viewDirectory: ViewDirectory,
        reviewChanges: ReviewChanges
    };

    const ToolComponent = toolComponents[item.name];
    if (!ToolComponent) return null;

    return <ToolComponent item={item} isInProgress={isInProgress} />;
};

export default ToolCall;